export default __webpack_public_path__ + "static/media/cameraIcon.4d36f09c.svg";